import React  from 'react';
import './App.scss';
import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import { useState, useEffect } from 'react';
import client from './sanity';


function App() {

  const [projects, setProjects] = useState([])
  useEffect(()=>{
    client.fetch(`
    *[_type == "project"] {
      ...,
      stacks[]->{
        ...,
      }
    }`
    ).then( data =>{
      setProjects(data)
    })
  },[])

  return (
    <>
    <Routes>
      <Route path="/" element={<Layout />} >
        <Route index element={<Home />} />
        <Route path='about' element={<About />} />
        <Route path='project' element={<Projects projects={projects}/>} />
        <Route path='contact' element={<Contact />} />
      </ Route>
    </Routes>
    </>
  );
}

export default App;
